import React from "react";
import {
  UserRoleMaintenancePageContent,
  UserRoleMaintenancePageStateProvider,
} from ".";

export const UserRoleMaintenancePage = () => {
  return (
    <>
      <UserRoleMaintenancePageStateProvider>
        <UserRoleMaintenancePageContent></UserRoleMaintenancePageContent>
      </UserRoleMaintenancePageStateProvider>
    </>
  );
};
